export default () => window.__DEFAULT_STATE__ || {}
